import React, { useEffect } from "react";

//** NDBX */
import { Section } from "@arp/react-ndbx";
//** MUI */
import { Typography } from "@mui/material";

//** Components */
import Page from "../../../components/Page";
import ButtonNavigationGroup from "../../../components/organisms/ButtonNavigationGroup.jsx";
import SelectCoverDetails from "../../../components/pageLevel/selectCoverDetails/SelectCoverDetails.jsx";

//** Context */
import { useOutletContext } from "react-router-dom";
import { Application } from "../../../config/const/enums.js";
import usePreQualification from "../../../hooks/usePreQualification.ts";
import usePreQualificationPages from "../../../hooks/usePreQualificationPages.ts";
import { trackifyPageChange } from "@allianz/tracking";

//----------------------------------------------------------------

export default function SelectCover({ person = "personOne" }) {
  const {
    showSecond: [showSecond],
  } = useOutletContext();

  const { state } = usePreQualificationPages();
  const { currentPage } = { ...state };
  const { dataSet } = usePreQualification();
  const isOnline = dataSet?.application === Application.ONLINE;

  useEffect(() => {
    trackifyPageChange(currentPage?.identifier?.toLowerCase());
  }, []);

  //----------------------------------------------------------------

  return (
    <Page title={currentPage.title} identifier={currentPage.identifier}>
      <Section mb={{ xs: 4, md: 8 }} mt={2}>
        <Typography variant="h2-bold">Select your cover</Typography>
      </Section>
      <SelectCoverDetails
        person="personOne"
        applicantTitle="1"
        dataSet={dataSet}
        isOnline={isOnline}
      />
      {showSecond ? (
        <SelectCoverDetails
          person="personTwo"
          applicantTitle="2"
          dataSet={dataSet}
          isOnline={isOnline}
        />
      ) : null}
      <ButtonNavigationGroup />
    </Page>
  );
}
